// import Pikaday from 'pikaday'
import datepicker from 'js-datepicker'

const $ = jQuery

export default function DatePicker () {
  const DATE_PICKER = datepicker('.datepicker', {
    startDay: 1,
    minDate: new Date(),
    customMonths: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
    customDays: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
    formatter: (input, date, instance) => {
      input.value = date.toLocaleDateString()
    },
    onSelect: instance => {
      const INPUT_WRAP = $(instance.el).closest('.input-wrap')
      if (INPUT_WRAP) {
        $(instance.el).val() !== ''
          ? INPUT_WRAP.addClass('active')
          : INPUT_WRAP.removeClass('active')
      }
    }
  })
  // const FIELDS = document.querySelectorAll('.datepicker')
  // if (FIELDS.length > 0) {
  //   for (let i = 0; i < FIELDS.length; i++) {
  //     const FIELD = document.querySelector('.datepicker')
  //     // const DATE_PICKER = new Pikaday({
  //     //   field: FIELD,
  //     //   minDate: new Date(),
  //     //   firstDay: 1,
  //     //   i18n: {
  //     //     previousMonth: 'Forrige Måned',
  //     //     nextMonth: 'Næste Måned',
  //     //     months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
  //     //     weekdays: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
  //     //     weekdaysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør']
  //     //   }
  //     // })
  //
  //     $(FIELD).on('change', function () {
  //       $(FIELD).val() !== ''
  //         ? $(this).closest('.input-wrap').addClass('active')
  //         : $(this).closest('.input-wrap').removeClass('active')
  //     })
  //   }
  // }
}
